import { axios, Response } from '../index'

export type GetFriendshipsResponse = {
  personaName: string
  personaId: string
  avatarUrl: string
}

const getFriendships = (
  companyId: string,
  personaType: string,
  personaId: string
): Response<GetFriendshipsResponse[]> => {
  return axios.get(`/v1/personas/${personaId}/friends`, {
    headers: {
      'X-CompanyID': companyId,
      'X-PersonaType': personaType,
      'X-PersonaID': personaId
    }
  })
}

export default getFriendships
